import { render } from "./CreateReflectionSubKomunitasView.vue?vue&type=template&id=bbbe7fa4"
import script from "./CreateReflectionSubKomunitasView.vue?vue&type=script&lang=js"
export * from "./CreateReflectionSubKomunitasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__